import usePlayerIdentity from './usePlayerIdentity';
export default function usePlayerDisplayName(username,fallback='Rakip'){
 const profile=usePlayerIdentity(username);
 return String(username).toLowerCase()==='bilgisayar'?'Bilgisayar':profile.displayName||fallback;
}
